export type ObservationGroupTranslateFn = (key: string) => string;

const GROUP_NAME_I18N_KEYS: Record<string, string> = {
  HeartAndBloodPressure: 'group-score-page.group-name.heart-and-blood-pressure',
  SleepAndRecovery: 'group-score-page.group-name.sleep-and-recovery',
  ActivityAndMovement: 'group-score-page.group-name.activity-and-movement',
  MetabolicAndWeight: 'group-score-page.group-name.metabolic-and-weight',
  MindAndMood: 'group-score-page.group-name.mind-and-mood',
};

const GROUP_NAME_FALLBACKS: Record<string, string> = {
  HeartAndBloodPressure: 'Heart and Blood Pressure',
  SleepAndRecovery: 'Sleep and Recovery',
  ActivityAndMovement: 'Activity and Movement',
  MetabolicAndWeight: 'Metabolic and Weight',
  MindAndMood: 'Mind and Mood',
};

export function getObservationGroupDisplayName(
  groupType: string | null | undefined,
  translate?: ObservationGroupTranslateFn,
): string {
  if (!groupType) {
    return '';
  }

  const key = GROUP_NAME_I18N_KEYS[groupType];
  if (translate && key) {
    const translated = translate(key);
    if (translated && translated !== key) {
      return translated;
    }
  }

  return GROUP_NAME_FALLBACKS[groupType] ?? groupType;
}
